export const COLLECTIONS = {
  LOCATIONS: 'locations',
  STAFF: 'staff',
  PUBLIC_STAFF: 'publicStaff',
  SERVICES: 'services',
  PRODUCTS: 'products',
  CLIENTS: 'clients',
  APPOINTMENTS: 'appointments',
  APPOINTMENT_HOLDS: 'appointmentHolds',
  STAFF_TIME_BLOCKS: 'staffTimeBlocks',
  SALES: 'sales',
  TERMINAL_CONFIGURATIONS: 'terminalConfigurations',
  GIFT_CARDS: 'giftCards',
  CUSTOM_FORMS: 'customForms',
  FORM_SUBMISSIONS: 'formSubmissions',
  TIME_CLOCK: 'timeClock',
  PAYROLL_RUNS: 'payrollRuns',
  PAY_ADJUSTMENTS: 'payAdjustments',
  REPORT_AGGREGATES: 'reportAggregates',
  CASH_DRAWER_DAYS: 'cashDrawerDays',
  MESSAGE_EVENTS: 'messageEvents',
  CONSENTS: 'consents',
  AI_RECEPTIONIST_SESSIONS: 'aiReceptionistSessions',
  STAFF_TASKS: 'staffTasks',
  AUDIT_LOGS: 'auditLogs',
} as const;

export type CollectionName = (typeof COLLECTIONS)[keyof typeof COLLECTIONS];
